<template>
  <div class="flex flex-col space-y-5">
    <BaseInput
      :label="$t('new.title_armenian')"
      v-model="store.newArtwork.title.hy"
      :placeholder="$t('new.title_armenian_placeholder')"
    />
    <BaseTextArea
      :label="$t('new.description_armenian')"
      v-model="store.newArtwork.description.hy"
      :placeholder="$t('new.description_armenian_placeholder')"
    />
  </div>
</template>

<script setup lang="ts">
const store = useNewArtworkStore();
</script>
